import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import { getSubscriptionStatus } from 'src/api';
import { useBoolean } from 'src/hooks/use-boolean';
import { subscriptionStatusKeys } from 'src/utils/query-keys';
import { isSuccessResponse } from 'src/utils/response-type-guards';
import { setSubscriptionBlockedHandler } from 'src/utils/axios';
import { useAuthContext } from 'src/auth/hooks';

// ----------------------------------------------------------------------

export const useSubscriptionStatus = () => {
  const { platformId, authenticated } = useAuthContext();

  const { data, isLoading } = useQuery({
    queryKey: subscriptionStatusKeys.detail(platformId),
    queryFn: getSubscriptionStatus,
    enabled: authenticated && !!platformId,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
  });

  const { value: isBlockedByApi, onTrue: onBlockedByApi, onFalse: offBlockedByApi } = useBoolean();

  useEffect(() => {
    offBlockedByApi();
    setSubscriptionBlockedHandler(onBlockedByApi);

    return () => setSubscriptionBlockedHandler(null);
  }, [platformId, onBlockedByApi, offBlockedByApi]);

  return {
    data: data && isSuccessResponse(data) ? data : null,
    isLoading,
    isBlockedByApi,
  };
};
